module.exports = __webpack_public_path__ + "static/media/typing.0566b9e6.mp4";